import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import SecuritySettings from '../components/settings/SecuritySettings';
import OrganizationSettings from '../components/settings/OrganizationSettings';
import { useLanguage } from '../contexts/LanguageContext';

const Settings = () => {
  const { t } = useLanguage();
  
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      
      <div className="flex-1 flex flex-col">
        <Header />
        
        <main className="flex-1 p-6">
          <div className="bg-white rounded-xl shadow-sm border p-4 pb-3 lg:p-5 lg:pb-4 mb-6">
            <div className="mb-2">
              <h1 className="text-2xl font-bold text-gray-900 mb-1 flex items-center">
                <SettingsIcon className="w-6 h-6 text-blue-600 mr-2" />
                {t('settings.title')}
              </h1>
              <p className="text-gray-500 text-sm tracking-wide">{t('settings.subtitle')}</p>
            </div>
          </div>

          <div className="space-y-6">
            <OrganizationSettings />
            <SecuritySettings />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Settings;